var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "53F4A571-5394-4375-BD1F-9442C7F2BE98") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.-Question-time-Q1---answers-UI",
    transform: "translate(-759.000000, -372.000000)",
    fill: "#CD2323",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel-2",
    transform: "translate(759.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3187901,4.68130828 C21.0758637,-1.56043609 10.9231046,-1.56043609 4.68017821,4.68130828 C-1.5600594,10.9230526 -1.5600594,21.0786513 4.68017821,27.3203957 C7.80164139,30.4406113 11.9008754,32 16.000172,32 C20.0994685,32 24.1973269,30.4405488 27.3187901,27.3203957 C33.5604033,21.0787138 33.5604033,10.9230526 27.3187901,4.68130828 Z M22.6018915,20.7171618 C23.1234485,21.2387297 23.1234485,22.0818301 22.6018915,22.6033981 C22.3417696,22.8635254 22.000297,22.994277 21.6587619,22.994277 C21.3172894,22.994277 20.9757543,22.8635254 20.7156323,22.6033981 L16.0001094,17.8864004 L11.2858996,22.6020224 C11.0244646,22.8621498 10.6829295,22.9929013 10.34277,22.9929013 C10.0012975,22.9929013 9.65976239,22.8621498 9.39964046,22.6020224 C8.87808348,22.0804544 8.87808348,21.2360409 9.39964046,20.7157861 L14.1138502,16.0001641 L9.39832734,11.2845422 C8.87677036,10.7629742 8.87677036,9.9185607 9.39832734,9.39830591 C9.91857121,8.87673797 10.762967,8.87673797 11.284524,9.39830591 L16.0000469,14.1139279 L20.7155698,9.39830591 C21.2371268,8.87673797 22.0802095,8.87673797 22.6017665,9.39830591 C23.1233234,9.9185607 23.1233234,10.7629742 22.6017665,11.2845422 L17.8862436,16.0001641 L22.6018915,20.7171618 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel2);
export default __webpack_public_path__ + "static/media/cancel-2.f4475f66.svg";
export { ForwardRef as ReactComponent };